import { render, staticRenderFns } from "./AssetsDefault.vue?vue&type=template&id=31d7be5e&"
import script from "./AssetsDefault.vue?vue&type=script&lang=js&"
export * from "./AssetsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports